import type { SEmbedConfig } from "@norma-bi/bi-api";

export function sEmbedAppPath(config: SEmbedConfig) {
  return `/embed/workspaces/${encodeURIComponent(config.workspaceKey)}/apps/${encodeURIComponent(config.appKey)}`;
}

export function sNavigationHostPath(path: string, config: SEmbedConfig): string | null {
  const origin = new URL(config.webUiUrl).origin;
  const url = new URL(path, origin);
  const base = sEmbedAppPath(config);
  if (url.origin !== origin || (url.pathname !== base && !url.pathname.startsWith(`${base}/`))) {
    return null;
  }
  return `/home${url.pathname.slice(base.length)}${url.search}${url.hash}`;
}

export function sHostSettingsPath(url: string, hostOrigin: string): string | null {
  const target = new URL(url, hostOrigin);
  if (
    target.origin !== hostOrigin ||
    (target.pathname !== "/settings" && !target.pathname.startsWith("/settings/"))
  ) {
    return null;
  }
  return `${target.pathname}${target.search}${target.hash}`;
}

const HOME_PATH_KEY = "s-embed-home-path";

/** Remembers where the user was in S, so leaving Settings returns there instead of to the start. */
export function rememberHomePath(path: string) {
  try {
    sessionStorage.setItem(HOME_PATH_KEY, path);
  } catch {
    // Without storage, Back to Home opens S's start page.
  }
}

/** Forgets it on sign-out, so the next user in this tab starts on S's start page. */
export function forgetHomePath() {
  try {
    sessionStorage.removeItem(HOME_PATH_KEY);
  } catch {
    // Nothing was saved.
  }
}

export function homePath(fallback: string): string {
  try {
    return sessionStorage.getItem(HOME_PATH_KEY) ?? fallback;
  } catch {
    return fallback;
  }
}
